import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { PechkinService } from 'app/pechkin/test/services/pechkin.service';
import { Sms } from 'app/pechkin/test/services/sms';
import { TemplateService } from 'app/mdm/template/services/template.service';
import { Template } from 'app/mdm/template/services/template';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from '@heda/core-hospital-ui';

@Component({
  selector: 'hw-sms-test',
  templateUrl: './sms-test.component.html',
})
export class SmsTestComponent implements OnInit {
  sms: Sms = new Sms();
  form: UntypedFormGroup;
  templates: Array<Template>;

  constructor(
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private pechkinService: PechkinService,
    private messageService: MessageService,
    private templateService: TemplateService,
    private translateService: TranslateService
  ) {
    this.form = this.createForm(this.fb);
  }

  ngOnInit(): void {
    this.templateService.loadTemplates('sms').subscribe((resp) => (this.templates = resp));
  }

  private createForm(fb: UntypedFormBuilder): UntypedFormGroup {
    return fb.group({
      receiver: [null, [Validators.required]],
      message: ['', [Validators.required]],
      template: [''],
    });
  }

  send(): void {
    const formDataValue = this.form.value;
    const sms = Object.assign(this.sms, {
      receiver: '00372' + formDataValue.receiver,
      message: formDataValue.message,
    });
    this.pechkinService.sendSms(sms).subscribe(
      () => {
        this.messageService.success('pechkin.test-01.message.success');
      },
      (err) => {
        this.messageService.error('pechkin.test-01.message.error');
      }
    );
  }

  templateChange(value: Template): void {
    const language = this.translateService.currentLang;
    this.templateService
      .getTemplate(value.code)
      .subscribe((resp) => this.form.patchValue({ message: resp.content[language] }));
  }
}
